import { useTranslation } from 'react-i18next'

import { format } from 'date-fns'

import { RelatedAudience } from 'app/audiences/types'

import { Section } from 'components'

import styles from './Related.module.scss'

interface RelatedProps {
  audiences: RelatedAudience[]
  className?: string
}

const Related = ({ audiences, className }: RelatedProps) => {
  const { t } = useTranslation('audiences')

  return (
    <div className={[styles.related, className].join(' ')}>
      <Section name={t('details.related.title')} />
      <div className={styles.audiences}>
        {audiences.map((audience, index) => (
          <div className={styles.row} key={index}>
            <div className={styles.property} title={audience.name}>
              {audience.name}
            </div>
            <div className={styles.value}>
              {audience.created ? format(audience.created, 'MMM dd, HH:mm aa') : '-'}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Related
